"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableProvider = exports.TableContext = void 0;
var _react = require("react");
/**
 * Used by Table.SortableHeaderCell to set icon alignments.
 */
var TableContext = /*#__PURE__*/(0, _react.createContext)({});
exports.TableContext = TableContext;
var TableProvider = TableContext.Provider;
exports.TableProvider = TableProvider;